import React, { useEffect, useRef } from "react";
import QRCodeStyling from "qr-code-styling";
import { Button, Space, Tooltip } from "antd";
import { faDownload, faPrint } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import logo from "../../../images/bizzll-icon.png";

const StyledQRCode = ({ url }) => {
  const qrRef = useRef(null);
  const qrCode = useRef(null);

  useEffect(() => {
    if (!url || !qrRef.current) return;

    qrRef.current.innerHTML = "";

    qrCode.current = new QRCodeStyling({
      width: 200, // tamaño físico del canvas
      height: 200,
      data: url,
      image: logo,
      imageOptions: {
        crossOrigin: "anonymous",
        margin: 5,
        imageSize: 0.5,
      },
    });

    qrCode.current.append(qrRef.current);
  }, [url]);

  const downloadQR = () => {
    qrCode.current.download({ extension: "png" });
  };

  const printQR = () => {
    qrCode.current.getRawData("png").then((blob) => {
      const urlImg = URL.createObjectURL(blob);
      const printWindow = window.open("", "", "width=400,height=400");
      printWindow.document.write(`
        <html>
          <head><title>Print QR</title></head>
          <body style="display:flex;justify-content:center;align-items:center;height:100vh;">
            <img src="${urlImg}" style="width:300px;height:300px;" />
            <script>
              window.onload = () => {
                window.print();
                window.onafterprint = () => window.close();
              };
            </script>
          </body>
        </html>`);
      printWindow.document.close();
    });
  };

  return (
    <div style={{ textAlign: "center" }}>
      <div className="qr-wrapper">
        <div ref={qrRef} className="qr-inner" />
      </div>
      <Space style={{ marginTop: 16 }}>
        <Button onClick={downloadQR}>
          <Tooltip title="Download QR Code">
            <FontAwesomeIcon icon={faDownload} />
          </Tooltip>
        </Button>
        <Button onClick={printQR}>
          <Tooltip title="Print QR Code">
            <FontAwesomeIcon icon={faPrint} />
          </Tooltip>
        </Button>
      </Space>
    </div>
  );
};

export default StyledQRCode;
